// 服务端接口的 baseURL http://localhost:48086/app-api https://chatapi.dtsofts.com/app-api https://chatdemo.dtsofts.com/app-api
// export const apiBaseURL = 'https://chatapi.dtsofts.com/app-api'
export const apiBaseURL = 'https://chatdemo.dtsofts.com/app-api'

// 建立 websocket 的 baseURL ws://192.168.2.168:48086/infra/ws  https://chatws.dtsofts.com  wss://chatws.dtsofts.com ws://101.132.174.197:48080/infra/ws
export const wsBaseURL = 'ws://101.132.174.197:48080/infra/ws'


